<template>
  <div class="flex justify-center items-center pt-12">
    <v-form name="formUserProfile" class="shadow-box border border-gray-100 bg-white rounded-md shadow-md"
      style="border:1px solid #e0e0e0; padding:10px; width:100%; max-width:900px; margin:0 auto;">
      <Tabs value="0" scrollable>
        <TabList class="mb-4">
          <Tab value="0">{{ __('Basic data') }}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel value="0">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8 justify-items-center">
              <FormInputText fieldName="last_name" label="Last name" size="3" :isFormDisabled="true" :isFocus="true"
                v-model:field="user.last_name" class="w-full h-12 text-base" />

              <FormInputText fieldName="first_name" label="First name" size="3" :isFormDisabled="true"
                v-model:field="user.first_name" class="w-full h-12 text-base" />

              <FormInputText fieldName="email" label="Email" size="3" :isFormDisabled="true" v-model:field="user.email"
                class="w-full h-12 text-base" />

              <FormInputMask fieldName="phone" label="Phone" size="3" mask="(+99) 999-999-999"
                placeholder="(+99) 999-999-999" v-model:field="user.phone" class="w-full h-12 text-base" />

              <FormPassword fieldName="password" label="Password" size="3" v-model:field="user.password"
                class="w-full h-12 text-base" />

              <FormPassword fieldName="retype_password" label="Retype password" size="3" v-model:field="retypePassword"
                class="w-full h-12 text-base" />

              <!-- <FormRadioButton fieldName="menu"
                                             label="Menu"
                                             size="2"
                                             :data="menuTypes"
                                             v-model:field="user.menu"
                                             class="w-full" />

                            <FormInputToggleButton v-if="user.menu == 'V'"
                                                   fieldName="is_expandable_menu"
                                                   label="Hiddenable side menu"
                                                   size="2"
                                                   v-model:field="user.is_expandable_menu"
                                                   class="w-full" /> -->

              <!-- <FormRadioButton fieldName="page_length"
                                             label="Page length"
                                             size="3"
                                             :data="select?.page_length"
                                             v-model:field="user.page_length"
                                             class="w-full" /> -->
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
      <div style="margin-top:20px;text-align:right;margin-left:auto;margin-right:auto;">
        <hr style="margin-bottom:20px">
        <div class="flex justify-content-end">
          <Button @click="saveData" :disabled="user.processing" style="margin:0 5px" severity="success"
            class="bg-secondary-500 hover:bg-gray-200 text-white hover:text-gray-600 font-medium py-1 px-2.5 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150 flex items-center gap-2">
            {{ __('Save') }}
          </Button>
          <Button @click="cancelData" :disabled="user.processing" style="margin:0 5px" severity="secondary"
            class="bg-white hover:bg-gray-200 text-gray-600 font-medium py-1 px-2.5 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150 flex items-center gap-2">
            {{ __('Cancel') }}
          </Button>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormRadioButton from '@crud/FormRadioButton.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import FormInputText from '@crud/FormInputText.vue'
import FormInputMask from '@crud/FormInputMask.vue'
import FormPassword from '@crud/FormPassword.vue'
import Button from 'primevue/button';
import { useForm, router, usePage } from '@inertiajs/vue3';
import { onErrorService, prepareSelect } from '@pages/Helper/crud_utils.js'
import { __, screenMessage, getAppName, clearSessionStorageByPrefix } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  data: Object,
})

const options = ["page_length"];
const select = ref(null);
const user = ref({ ...props.data, 'password': '' })
const retypePassword = ref("");

// -----------------------------------------------------

onMounted(async () => {
  select.value = await prepareSelect(options)
});

// -----------------------------------------------------

const beforeSave = (sourceForm) => {
  if (sourceForm.password !== retypePassword.value) {
    const message = {
      message: "Passwords not match",
      title: "Password error",
      type: "error",
      position: "center",
      timeout: 10,
    };

    screenMessage(message);
    return false;
  }
  return true;
};

// -----------------------------------------------------

const saveData = () => {
  const success = beforeSave(user.value);
  if (success) {
    useForm(user.value).post(route('user-update-profile'), {
      preserveState: true,
      preserveScroll: true,
      onError: (errors) => {
        onErrorService(errors)
      },
      onSuccess: () => {
        const appName = getAppName()
        clearSessionStorageByPrefix(appName + '-', ['rows'])
      },
    })
  }
}

// -----------------------------------------------------

const cancelData = () => {
  router.get(route('system-start'));
}

// -----------------------------------------------------

const menuTypes = [
  { label: 'poziome', value: 'H' },
  { label: 'pionowe', value: 'V' },
]

// -----------------------------------------------------

const languages = [
  { label: 'polski', value: 'pl' },
  { label: 'angielski', value: 'en' },
]

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
